// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"923":"eb85d5174ef5f89babe6","8397":"f67ef86d0d5f51ec4ae2"}[chunkId] + ".js";
};